import { useEffect, useState } from 'react';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import spacing from 'material-ui/styles/spacing';
import * as MaterialUiColors from 'material-ui/styles/colors';
import * as MaterialUiColorManipulator from 'material-ui/utils/colorManipulator';
import type { InitConfigurationStaticAssetsState } from '@makemydeal/dr-dash-types';
import { getThemeModule } from '@makemydeal/dr-dash-ui-utils';

type ThemeContent = Record<string, string>;

export const useTheme = (staticAssets: InitConfigurationStaticAssetsState | undefined) => {
    const [theme, setTheme] = useState<ThemeContent>({});

    const getTheme = () => {
        const primaryFont = theme.muiFontFamily;

        return getMuiTheme({
            spacing,
            fontFamily: primaryFont,
            palette: {
                primary1Color: theme.headerFooterCommonBackgroundGradientColor1,
                primary2Color: theme.headerFooterCommonBackgroundGradientColor1,
                primary3Color: MaterialUiColors.grey400,
                accent1Color: MaterialUiColors.white,
                accent2Color: theme.headerFooterCommonBackgroundGradientColor1,
                accent3Color: MaterialUiColors.grey500,
                textColor: MaterialUiColors.darkBlack,
                alternateTextColor: theme.headerFooterContainerColor,
                canvasColor: MaterialUiColors.white,
                borderColor: MaterialUiColors.grey300,
                disabledColor: MaterialUiColorManipulator.fade(MaterialUiColors.darkBlack, 0.3),
                pickerHeaderColor: theme.headerFooterCommonBackgroundGradientColor1,
                clockCircleColor: MaterialUiColorManipulator.fade(MaterialUiColors.darkBlack, 0.07),
                shadowColor: MaterialUiColors.fullBlack
            }
        });
    };

    useEffect(() => {
        getThemeModule(staticAssets)
            .then((data: ThemeContent) => {
                setTheme(data);
            })
            .catch((error) => {
                let loadingItemText;
                if (staticAssets) {
                    loadingItemText = staticAssets.legacyThemeJson;
                } else {
                    loadingItemText = '(static assets undefined)';
                }
                // eslint-disable-next-line no-console
                console.error(`Error during loading of ${loadingItemText} theme token: ${error}`);
            });
    }, [staticAssets]);

    return {
        theme,
        getTheme
    };
};
